import {MI} from "../init";
import {ServerResult} from "../ServerResult";
import {ResultController} from "./ResultController";
import {ReelsSpinner} from "../reel/ReelsSpinner";
import {GameHeader} from "./GameHeader";
import {getRandomInt} from "../../framework/src/helpers";
import events from "../../framework/src/events/EventsObservable";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {STATES} from "../../framework/src/states/states";
import {states} from "../../framework/src/engine/madnes/madnes_variables";
import * as MV from "../../framework/src/engine/madnes/madnes_variables";
import {
	madnes_add_win,
	madnes_reels_start,
	madnes_reels_stop,
	madnes_set_win
} from "../../framework/src/engine/madnes/madnes";
import {StormSearch} from "./StormSearch";
import AddResult from "../../framework/src/connect/result/AddResult";

/**
 * @constructor
 */
export function Game() {
	/** @type {boolean} */
	this.inPreinfo = false;

	/** @type {GameConfig} */
	this.gameCfg;

	/** @type {SpinReels} */
	this.spinReels;

	/** @type {ReelsSpinner} */
	this._reelsSpinner;

	/** @type {ReelPrinter} */
	this._printer;

	/** @type {ServerCfg} */
	this._serverConfig;

	/** @type {ResultController} */
	this._resultController;

	/** @type {SymbolsManager} */
	this._symbolsManager;

	/** @type {GameAssets} */
	this.assets;

	/** @type {ServerResult} */
	this._serverResult = new ServerResult();

	/** @type {ServerResult|null|undefined} */
	this._fsServerResult = null;

	this.gameRoundWin = 0;
	this.gameTotalCredit = 0;

	this.inBonusChoose = false;

	/** @type {boolean} */
	this._inFreeSpins = false;

	/** @type {number} */
	this.inFreeSpinsIndex = -1;

	/** @type {boolean} */
	this._countFs = true;

	/** @type {number} */
	this.respinIndex = 0;

	this._resultRequestLock = false;

	/**
	 * @type {Promise|null}
	 */
	this.waitForWinAdd = null;

	this._removeBetEnabled = true;

	this.freeSpinData = {
		'roundWin': 0,
		'count': 0,
		'pos': 0
	};

	this.fsSkip = false;

	/** @type {Object<string,MadnesAudio>} */
	this.sounds = {};

	/** @type {MadnesTimer} */
	this._bgMusicTimeout;

	/** @type {boolean} */
	this._forceStopSoundPlayed = false;

	/** @type {boolean} */
	this._forceScatterSoundPlayed = false;

	/** @type {GameHeader} */
	this.header;

	this.spinEnabled = true;

	/** @type {boolean} */
	this._forceAutostartEnabled = false;

	this._reelSoundIndex = 1;

	events.subscribe(GAME_EVENTS.GAME_ADD_RESULT, this._requestResult.bind(this));
	events.subscribe(GAME_EVENTS.GAME_END_ROUND_RECALCED, this._endRoundRecalced.bind(this));
};

/** @const */
Game.prototype.NORMAL_WIN = 0;
/** @const */
Game.prototype.BIG_WIN = 1;
/** @const */
Game.prototype.MEGA_WIN = 2;
/** @const */
Game.prototype.SUPER_MEGA_WIN = 3;
/** @const */
Game.prototype.BONUS_WIN = 4;
/** @const */
Game.prototype.FS_WIN = 5;

Game.prototype.reinitFreespinData = function() {
	this.freeSpinData = {
		'roundWin': 0,
		'count': 0,
		'pos': 0
	};
};

/**
 * @param {number} val
 * @returns {undefined}
 */
Game.prototype.setFreeSpinRoundWin = function(val) {
	this.freeSpinData["roundWin"] = val;
};

/**
 * @returns {number}
 */
Game.prototype.getFreeSpinRoundWin = function() {
	return this.freeSpinData["roundWin"];
};

Game.prototype.setInFreeSpins = function(bool) {
	MI.setInFreeSpins(bool);
	this._inFreeSpins = bool;
};

Game.prototype.isInFreeSpins = function() {
	return this._inFreeSpins;
};

/**
 * @returns {boolean}
 */
Game.prototype.stopBonusScatterSound = function() {
	return !!(!this._fsServerResult && this._serverResult.getFreeSpinResults());
};

Game.prototype._playBgScatterIdle = function() {
	setTimeout(function() {
		if(this.inBonusChoose) {
			this.sounds["bg_Scatter_Idle"].loop();
		}
	}.bind(this), 10500);
};

/**
 * @param {SpinReels} spinReels
 * @param {GameConfig} gameConfig
 * @param {ReelPrinter} reelPrinter
 * @param {ServerCfg} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @param {GameAssets} gameAssets
 * @returns {undefined}
 */
Game.prototype.init = function(spinReels, gameConfig, reelPrinter, serverConfig, symbolsManager, gameAssets) {

	this.spinReels = spinReels;
	this.gameCfg = gameConfig;
	this._printer = reelPrinter;
	this._serverConfig = serverConfig;
	this._symbolsManager = symbolsManager;
	this.assets = gameAssets;

	this._resultController = new ResultController(this, symbolsManager);
	//this._resultController.init();

	this._reelsSpinner = new ReelsSpinner(this.spinReels);

	this._reelsSpinner.setOnStart(this._onReelsStart.bind(this));
	this._reelsSpinner.setOnBrakeDown(this._onReelBrakeDown.bind(this));
	this._reelsSpinner.setOnBrakeUp(this._onReelBrakeUp.bind(this));
	this._reelsSpinner.setOnStop(this._onReelStop.bind(this));
	this._reelsSpinner.setOnComplete(this._onReelsComplete.bind(this));

	this.sounds["bg_Ambient"] = MI.addAudio("bg_Ambient").loop();
	this.sounds["bg_Music"] = MI.addAudio("bg_Music");

	this.sounds["reel_Start_1"] = MI.addAudio("reel_Start_1");
	this.sounds["reel_Start_2"] = MI.addAudio("reel_Start_2");
	this.sounds["reel_Start_3"] = MI.addAudio("reel_Start_3");

	this.sounds["symbol_Ship_1"] = MI.addAudio("symbol_Ship_1");
	this.sounds["symbol_Ship_2"] = MI.addAudio("symbol_Ship_2");
	this.sounds["symbol_Ship_3"] = MI.addAudio("symbol_Ship_3");

	this.sounds["reel_Stop"] = MI.addAudio("reel_Stop").allowMultiple();

	this.sounds["win_Axe"] = MI.addAudio("win_Axe").allowMultiple();
	this.sounds["win_Bracelet"] = MI.addAudio("win_Bracelet").allowMultiple();
	this.sounds["win_Helmet"] = MI.addAudio("win_Helmet").allowMultiple();
	this.sounds["win_Letter"] = MI.addAudio("win_Letter").allowMultiple();
	this.sounds["win_Shield"] = MI.addAudio("win_Shield").allowMultiple();
	this.sounds["win_Ship"] = MI.addAudio("win_Ship").allowMultiple();
	this.sounds["win_Viking"] = MI.addAudio("win_Viking").allowMultiple();
	this.sounds["win_Woman"] = MI.addAudio("win_Woman").allowMultiple();

	this.sounds["win_Multiplier_Axe"] = MI.addAudio("win_Multiplier_Axe").allowMultiple();;
	this.sounds["win_Multiplier_Bracelet"] = MI.addAudio("win_Multiplier_Bracelet").allowMultiple();;
	this.sounds["win_Multiplier_Helmet"] = MI.addAudio("win_Multiplier_Helmet").allowMultiple();;
	this.sounds["win_Multiplier_Letter"] = MI.addAudio("win_Multiplier_Letter").allowMultiple();;
	this.sounds["win_Multiplier_Shield"] = MI.addAudio("win_Multiplier_Shield").allowMultiple();;
	this.sounds["win_Multiplier_Viking"] = MI.addAudio("win_Multiplier_Viking").allowMultiple();;
	this.sounds["win_Multiplier_Woman"] = MI.addAudio("win_Multiplier_Woman").allowMultiple();;

	this.sounds["reel_Search_Long"] = MI.addAudio("reel_Search_Long");
	this.sounds["reel_Search_Short"] = MI.addAudio("reel_Search_Short");

	this.sounds["bonus_FreeSpins_Counter"] = MI.addAudio("bonus_FreeSpins_Counter").allowMultiple();
	this.sounds["bonus_FreeSpins_In"] = MI.addAudio("bonus_FreeSpins_In");
	this.sounds["bonus_Arrow_1"] = MI.addAudio("bonus_Arrow_1").allowMultiple();
	this.sounds["bonus_Arrow_2"] = MI.addAudio("bonus_Arrow_2").allowMultiple();
	this.sounds["bonus_Lock_Fire"] = MI.addAudio("bonus_Lock_Fire").allowMultiple();

	this.sounds["bg_FreeSpins_Start"] = MI.addAudio("bg_FreeSpins_Start");
	this.sounds["bg_FreeSpins_Loop"] = MI.addAudio("bg_FreeSpins_Loop");

	this.sounds["bwin_BigWin"] = MI.addAudio("bwin_BigWin");
	this.sounds["bwin_FreeSpins"] = MI.addAudio("bwin_FreeSpins");
	this.sounds["bwin_BigWin_Counter"] = MI.addAudio("bwin_BigWin_Counter").allowMultiple();
	this.sounds["bwin_BigWin_Thunder"] = MI.addAudio("bwin_BigWin_Thunder");
	this.sounds["bwin_Money"] = MI.addAudio("bwin_Money");
	this.sounds["bwin_Money_Short"] = MI.addAudio("bwin_Money_Short");

	for(var i = 1; i <= 5; i++) {
		this.sounds["misc_Coin_Drop_" + i] = MI.addAudio("misc_Coin_Drop_" + i);
	}
};

Game.prototype.canRemoveBet = function() {

	if(this.isInFreeSpins() || !this._removeBetEnabled /*|| MI.isLastRoundAutostart()*/) {
		return false;
	}

	return true;
};

/**
 * @param {boolean} bool FALSE to disable remove bet
 * @returns {undefined}
 */
Game.prototype.enableRemoveBet = function(bool) {
	this._removeBetEnabled = bool;
};

/**
 * @returns {boolean}
 */
Game.prototype.isInAutostart = function() {
	return MI.isAutoStartSet();
};

Game.prototype.endAutostart = function() {
	MI.endAutoStart();
};

Game.prototype.spinStart = function() {
	var _self = this;

	if(!this.spinEnabled) {
		return;
	}

	this.spinEnabled = false;

	this._forceAutostartEnabled = false;

//	if(this.roundRunning() && !this.isRespin && !this.isInFreeSpins()) {
//		return;
//	}
//
//	if(this.isState("SPINNING") && !this.isRespin) {
//		console.warn("game running");
//		return;
//	}

	this._resultRequestLock = false;

	MI.controls.unsetForceStop();

	if(!this.isInFreeSpins()) {
		if(!this.sounds["bg_Music"].isPlaying()) {
			this.sounds["bg_Music"].loop();
			this.sounds["bg_Music"].setVolume(0);
		}
		this.sounds["bg_Music"].fadeToInit(1000);
	}

	this.stopBgMusicTimer();

	//this._decreaseAutoStartCount();
	this._increaseFreeSpins();

	// var money = MI.getMoney();

	//madnes_new_round();
	// madnes_inc_round();

	// this._requestResult(money);
	// this._removeBet();

	madnes_reels_start();

	this._reelsSpinner.spin().then(function() {
		_self._resultController.control(_self._getServerResult());
	});
};

/**
 * @returns {Promise}
 */
Game.prototype.respinStart = function() {

	this._resultRequestLock = false;

	var spin = this._reelsSpinner.spin();

	this._requestResult();

	return spin;
};

Game.prototype._onReelsStart = function() {

	MI.controls.unsetForceStop();
	MI.setState("ROTATED", 1);
	// MI.controls.showStop();

	if(!this.isRespin) {
		MI.controls.winAnimReset();
		// madnes_on_round_start();
	}

	this.sounds['reel_Start_' + getRandomInt(1, 3)].play();
};

Game.prototype._onReelsComplete = function() {
	madnes_reels_stop();
	// madnes_reels_end();

	this._forceStopSoundPlayed = false;
	this._forceScatterSoundPlayed = false;
	this._reelSoundIndex = 1;

	if(MI.controls.isForceStop()) {
		if(this.sounds["reel_Search_Short"].isPlaying()) {
			this.sounds["reel_Search_Short"].fadeOut(200, true);
		}
		if(this.sounds["reel_Search_Long"].isPlaying()) {
			this.sounds["reel_Search_Long"].fadeOut(200, true);
		}
	}

	MI.setState("ROTATED", 0);
	MI.controls.unsetForceStop();

};

/**  @param {SpinReel} reel */
Game.prototype._onReelStop = function(reel) {
	//console.log('stop');
	//console.timeEnd('r' + reel.id);

	var searchType = this._getServerResult().getSearchingScatter();
	if(reel.id === 1 && (searchType === 2 || searchType === 1) && !MI.controls.isForceStop()) {

		if(searchType === 1) {
			this.sounds["reel_Search_Short"].play();
		}
		if(searchType === 2) {
			this.sounds["reel_Search_Long"].play();
		}

		reel.storm = new StormSearch(this.assets.getStormGroup());
		reel.storm.create(2);
		reel.storm.run();

	}

	if(reel.id === 2 && searchType === 2 && !MI.controls.isForceStop()) {
		reel.storm = new StormSearch(this.assets.getStormGroup());
		reel.storm.create(3);
		reel.storm.run();
	}

	//this._setReelSpeed(reel, this._getServerResult());
	if (reel.id === 2 && !this._inFreeSpins) {
		states.setState(STATES.FORCESPIN);
	}
};

/**  @param {SpinReel} reel */
Game.prototype._onReelBrakeUp = function(reel) {
	if(reel.id === 3 && this._getServerResult().getSearchingScatter() < 2 && !this._getServerResult().getLineWins()) {
		states.setState(STATES.FORCESPIN);

		// this._forceAutostartEnabled = true;
		// MI.controls.showSpin();
	}
};

/** @param {SpinReel} reel */
Game.prototype._onReelBrakeDown = function(reel) {

//	if(reel.id == 0) {
//		console.log('brakedown reel 1');
//		console.time('r1');
//		console.time('r2');
//		console.time('r3');
//	}
//
//	if(reel.id > 0) {
//		console.timeEnd('r' + reel.id);
//	}

	if(reel.forceStopping) { //in force stop, play stop sound only once

		if(this._isScatterReel(reel)) {

			if(!this._forceScatterSoundPlayed) {
				this._playScatterStopSound();
				this._forceScatterSoundPlayed = true;
			}
			return;
		}

		if(!this._forceStopSoundPlayed) {
			this.sounds["reel_Stop"].play();
			this._forceStopSoundPlayed = true;
		}
		return;
	}

	if(this._isScatterReel(reel)) {
		this._playScatterStopSound();
		return;
	}

	this.sounds['reel_Stop'].play();
};

/**
 * @param {SpinReel} reel
 * @returns {boolean}
 */
Game.prototype._isScatterReel = function(reel) {
	return reel.hasScatter() && (reel.id === 1 || reel.id === 2 || reel.id === 3);
};

Game.prototype._playScatterStopSound = function() {
	if(typeof this.sounds["symbol_Ship_" + this._reelSoundIndex] !== 'undefined') {
		this.sounds["symbol_Ship_" + this._reelSoundIndex].play();
		this._reelSoundIndex++;
		return;
	} else {
		this.sounds['reel_Stop'].play();
	}
};

Game.prototype._requestResult = function(eventName, data) {

	if(this._resultRequestLock) {
		return;
	}

	var _self = this;

	this._resultRequestLock = true;

	this._getResult().then(function() {

		for(var i = 0; i < _self.spinReels.getReels().length; i++) {

			_self.spinReels.getReel(i).addSymbolsToStop(_self._getReelDuration(i, _self._getServerResult().getSearchingScatter()));
			_self.spinReels.getReel(i).stop();
		}

	});
};

Game.prototype._getResult = function() {

	var _self = this;

	return new Promise(function(res) {

		if(_self.isInFreeSpins()) {

			MI.createTimer().add(function() {
				_self._fsServerResult = _self._serverResult.getFreeSpinResult(_self.inFreeSpinsIndex);
				//var searchScatter = this._getServerResult().getSearchingScatter();

				_self.spinReels.prepareResult(_self._fsServerResult.getReelMatrix(_self.respinIndex)/*, searchScatter*/);
				res();
			}, 200);

		} else {

			_self._serverResult.init(MI.server.getResult());
			//var searchScatter = this._getServerResult().getSearchingScatter();

			//_self._setReelsSpeed(_self._getServerResult());
			_self.spinReels.prepareResult(_self._serverResult.getReelMatrix(0)/*, searchScatter*/);
			res();
		}
	});
};

/**
 * @returns {boolean}
 */
Game.prototype._isScatter = function() {
	return !!(this._getServerResult().getLineWins() && this._getServerResult().getSearchingScatter() > 1);
};

/**
 * @returns {ServerResult}
 */
Game.prototype._getServerResult = function() {
	return this._fsServerResult ? this._fsServerResult : this._serverResult;
};

Game.prototype.enterFreeSpins = function() {

	this.fsSkip = false;

	var reelStopInitVol = this.gameCfg.reelStopInitSound * 1.8;
	this.sounds["reel_Stop"].setInitVolume(reelStopInitVol * 1.8);

	var reelStartInitVol = this.gameCfg.reelStartInitSound * 1.6;
	this.sounds["reel_Start_1"].setInitVolume(reelStartInitVol);
	this.sounds["reel_Start_2"].setInitVolume(reelStartInitVol);
	this.sounds["reel_Start_3"].setInitVolume(reelStartInitVol);

	//console.log(reelStopInitVol, madnes_audio_get_volume("reel_Stop"));

	var _self = this;

	let fsCurrent = MV.freespins.getFreeSpinNumber();
	MV.game.freespins.run(new AddResult(this._serverResult.data));
	let fsTotal = MV.freespins.getFreeSpinNumber();

	this._countFs = true;

	this.respinIndex = 0;
	this.setInFreeSpins(true);

	this.freeSpinData["count"] = _self._serverResult.getFreeSpinResults().length;

	this.setFreeSpinRoundWin(0);

	// var cpos = MI.getCookie("lfspos_" + MI.server.getSessionId());
	if(MV.game.freespins.isSkipping() /*typeof cpos !== 'undefined' && cpos !== null && cpos * 1 >= 0*/) {

		this.fsSkip = true;

		_self.inFreeSpinsIndex = MV.freespins.getRoundIndex(); //fsCurrent * 1;

		var fsResult = _self._serverResult.getFreeSpinResult(_self.inFreeSpinsIndex);

		_self.freeSpinData["count"] = fsResult.getFreeSpinNumber();
		_self.freeSpinData["pos"] = MV.freespins.getRoundNumber(); // fsCurrent * 1 + 1;

		madnes_set_win(MV.game.freespins.getResultWin());
		// _self.setWin(MV.game.freespins.getResultWin());

		if(typeof fsResult.getWin() !== 'undefined') {
			// _self.setWin(fsResult.getWin());
			this.setFreeSpinRoundWin(0);
		}

		this.header.setFS(this.freeSpinData["pos"], this.freeSpinData["count"]);
		this._countFs = false;

	} else {
		this.header.setFS(0, 0);
	}

	this.header.showFS(200);
};

/**
 * @returns {Promise}
 */
Game.prototype.countFreeSpins = function() {
	if(this._countFs) {
		return this.header.countFS(0, this.freeSpinData["count"], this.freeSpinData["pos"]);
	} else {
		return new Promise(function(res) { res(); });
	}
};

Game.prototype.leaveFreeSpins = function() {

	this.reinitFreespinData();

	this.header.showLogo();

	this.sounds["bg_Music"].fadeToInit(500);

	this.setInFreeSpins(false);
	this.inFreeSpinsIndex = -1;
	this._fsServerResult = null;

	this.sounds["reel_Stop"].setInitVolume(this.gameCfg.reelStopInitSound);

	this.sounds["reel_Start_1"].setInitVolume(this.gameCfg.reelStartInitSound);
	this.sounds["reel_Start_2"].setInitVolume(this.gameCfg.reelStartInitSound);
	this.sounds["reel_Start_3"].setInitVolume(this.gameCfg.reelStartInitSound);
};

/**
 * @public
 * @returns {boolean}
 */
Game.prototype.isNextRoundFreeSpin = function() {
	return !!this._serverResult.getFreeSpinResult(this.inFreeSpinsIndex + 1);
};

// Game.prototype.setWin = function(val) {
//
// 	console.log("setWin", val);
//
// 	madnes_set_win(val);
// 	//MI.setWin(val);
// 	this.setFreeSpinRoundWin(val);
// };

/**
 * @param {number} val
 * @returns {undefined}
 */
Game.prototype.addWin = function(val) {
	madnes_add_win(val);
	//MI.setWin(this.getWin() + val);
	this.setFreeSpinRoundWin(this.getFreeSpinRoundWin() + val);
};

/**
 * @returns {number} money in `money`
 */
Game.prototype.getWin = function() {
	return MI.getWin();
};

/**
 * @returns {boolean}
 */
Game.prototype.isWin = function() {
	return this.getWin() > 0;
};

/**
 * @param {number} amount
 * @param {number} moneyBet
 * @returns {boolean}
 */
Game.prototype.isBigWin = function(amount, bet) {
	return amount >= MI.getBigWinFactor() * MI.getMoneyBet(bet);
};

/**
 * @param {number} amount
 * @param {number} bet
 * @returns {boolean}
 */
Game.prototype.isMegaWin = function(amount, bet) {
	return amount >= MI.getMegaWinFactor() * MI.getMoneyBet(bet);
};

/**
 * @param {number} amount
 * @param {number} bet
 * @returns {boolean}
 */
Game.prototype.isSuperMegaWin = function(amount, bet) {
	return amount >= MI.getSuperMegaWinFactor() * MI.getMoneyBet(bet);
};

Game.prototype.isBonusWin = function() {
	return false;
};

/**
 * @param {number} win
 * @param {number} bet
 * @returns {number}
 */
Game.prototype.getWinType = function(win, bet) {

	/*if(this.isInFreeSpins()) {

		return this.BONUS_WIN;

	} else*/ if(this.isSuperMegaWin(win, bet)) {

		return this.SUPER_MEGA_WIN;

	} else if(this.isMegaWin(win, bet)) {

		return this.MEGA_WIN;

	} else if(this.isBigWin(win, bet)) {

		return this.BIG_WIN;

	}

	return this.NORMAL_WIN;
};

/**
 * @private
 * @param {number} reelId
 * @param {number} searchingType
 * @returns {number}
 */
Game.prototype._getReelDuration = function(reelId, searchingType) {

	var duration = 0;
	var dbs = this._serverConfig.getDelayBetweenReelStops();
	var sdur = this._serverConfig.getScatterDuration();
	var sdel = this._serverConfig.getScatterDelay();

	switch(reelId) {
		case 0:
			return dbs * 0;

		case 1:
			return dbs * 1;

		case 2:

			if(searchingType == 1 || searchingType == 2) {
				return sdur + sdel;
			}

			return dbs * 2;

		case 3:

			if(searchingType == 1) {

				return sdur + sdel + dbs;
				//return sdur + sdel + 12 + 5 + dbs;

			} else if( searchingType == 2) {
				return (sdur + sdel) * 2;
			}

			return dbs * 3;

		case 4:

			if(searchingType == 1) {

				return sdur + sdel + dbs + dbs * 2;

			} else if( searchingType == 2) {

				return (sdur + sdel) * 2 + dbs;

			}

			return dbs * 4;
	}

	return duration;
};

// /**
//  * @param {ServerResult} serverResult
//  * @returns {undefined}
//  */
// Game.prototype._setReelsSpeed = function(serverResult) {
// 	var _self = this;
//
// 	var searchingType = serverResult.getSearchingScatter();
//
// 	if(searchingType === 1 || searchingType === 2) {
//
// 		var motion = this.spinReels.getReel(2).motion;
//
// 		var obj = {
// 			'speed': motion.getSpinSpeed()
// 		};
//
// 		var toSpeed = motion.calcSpinSpeed(this._serverConfig.getSpinScatterSpeed());
//
// 		MI.addTween().to(obj, { 'speed': toSpeed }, {
// 			'duration': 200,
// 			'update': function() {
// 				for(var i = 0, l = _self.spinReels.getReels().length; i < l; i++) {
// 					_self.spinReels.getReel(i).motion.setSpinSpeed(obj['speed']);
// 				}
// 			},
// 			'callback': function() {
// 				for(var i = 0, l = _self.spinReels.getReels().length; i < l; i++) {
// 					_self.spinReels.getReel(i).motion.setSpinSpeed(toSpeed);
// 				}
// 			}
// 		});
// 	}
// };

Game.prototype.runBgMusicTimer = function() {
	var _self = this;

	this._bgMusicTimeout && this._bgMusicTimeout.stop();
	this._bgMusicTimeout = MI.createTimer().add(function() {
		_self.sounds["bg_Music"].fadeOut(6000, false);
	}, 6000);
};

Game.prototype.stopBgMusicTimer = function() {
	this._bgMusicTimeout && this._bgMusicTimeout.stop();
	this._bgMusicTimeout = null;
};

Game.prototype._decreaseAutoStartCount = function() {
	if(MI.getAutoStart() !== "∞" && MI.getAutoStart() > 0 && !this.isInFreeSpins()) {
		MI.autoStartDec();
	}
};

Game.prototype._increaseFreeSpins = function() {
	if(this.isInFreeSpins() && !this.isRespin) {
		this.inFreeSpinsIndex++;
		this.freeSpinData['pos']++;
		this.header.setFS(this.freeSpinData['pos'], this.freeSpinData['count']);
	}
};

Game.prototype.increaseRespins = function() {
	this.respinIndex++;
};

/**
 * @returns {boolean}
 */
Game.prototype.isLastRespin = function() {
	return !this._fsServerResult.getReelMatrix(this.respinIndex);
};

/** @returns {boolean} */
Game.prototype.isNextRespin = function() {
	return !!this._fsServerResult.getReelMatrix(this.respinIndex + 1);
};

Game.prototype.resetRespins = function() {
	this.respinIndex = 0;
};

// Game.prototype._removeBet = function() {
//
// 	if(this.canRemoveBet() && !this.isRespin) {
// 		MI.moneyRemoveBet();
// 	}
// 	this.enableRemoveBet(true);
//
// 	MI.setLastRoundAutostartEnabled(false);
// };

/**
 * @returns {boolean}
 */
Game.prototype.roundRunning = function() {
	return MI.server.roundRunning();
};

Game.prototype.createHeader = function() {
	this.header = new GameHeader(this);
	this.header.create();
};

Game.prototype.setForceAutostartEnabled = function(enabled) {
	this._forceAutostartEnabled = enabled;
};

Game.prototype.spinReleased = function() {

	if(this._forceAutostartEnabled) {
		//console.log("spin pressed, setting autostart: true");
		this._resultController.setForceAutostart(true);
	}

	this._forceAutostartEnabled = false;
};

Game.prototype.forcestopPressed = function() {
	this._resultController.setForceAutostart(false);
};

Game.prototype._endRoundRecalced = function () {

	this.runBgMusicTimer();
	this.spinEnabled = true;

};